import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Table, Typography, Row, Col, Card, Button, Tooltip } from 'antd'
import moment from 'moment'
import { Redirect } from 'react-router-dom'
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined'
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const { Title } = Typography

const columns = [
    {
        title: 'Timestamp',
        dataIndex: 'timestamp',
        key: 'timestamp',
        sorter: (a, b) => moment(a.timestamp).unix() - moment(b.timestamp).unix(),
        sortDirections: ['descend'],
        defaultSortOrder: 'descend',
        width: '15%',
        render: (text) => {
            
            return(moment(text).format("MM-DD-YYYY hh:mm:ss A"))
        }
    },
    {
        title: 'Approval of the Minutes of the Annual Stockholders’ Meeting held on May 25, 2021',
        dataIndex: 'vote1',
        key: 'vote1',
        width: '10.625%',
    },
    {
        title: 'Election of Directors',
        dataIndex: 'vote2',
        key: 'vote2',
        width: '10.625%',
        render: (text, record) => (
            <>{text} <br />{record.nominees?.map(nominee => (<>{nominee}<br /></>))}</>
        )
    },
    {
        title: 'Ratification of the 2021 Audited Financial Statements',
        dataIndex: 'vote3',
        key: 'vote3',
        width: '10.625%',
    },
    {
        title: 'Appointment of Isla Lipana & Co. as external auditor',
        dataIndex: 'vote4',
        key: 'vote4',
        width: '10.625%',
    },
    {
        title: 'Ratification of all acts of Management and the Board of Directors',
        dataIndex: 'vote5',
        key: 'vote5',
        width: '10.625%',
    },
    {
        title: 'Approval of the Amendment of By-Laws changing the date of the annual stockholders’ meeting from the first Monday of April to June 8 of every year.',
        dataIndex: 'vote6',
        key: 'vote6',
        width: '10.625%',
    },
    {
        title: 'Approval of the issuance by the Company of fixed-rate bonds not exceeding thirty five percent (35%) of the value of its Deposited Property or up to the allowable leverage under the Real Estate Investment Trust (REIT) Act of 2009 (“REIT Law”) and its implementing rules and regulations (“REIT Law IRR”).',
        dataIndex: 'vote7',
        key: 'vote7',
        width: '10.625%',
    },
    {
        title: 'Name of Stockholder',
        dataIndex: 'fullname',
        key: 'fullname',
        width: '10.625%',
    },
    {
        title: 'Number of Shares',
        dataIndex: 'noOfShares',
        key: 'noOfShares',
        width: '10.625%',
    },
]

function Tabulation() {
    const [voters, setVoters] = useState(0)
    const [noVotes, setNoVotes] = useState(0)
    const [noShares, setNoShares] = useState(9)
    const auth = useSelector(state => state.auth)
    const users = useSelector(state => state.users)
    const votes = useSelector(state => state.votes)
    const [excelvotes, setExcelvotes] = useState([])

    useEffect(() => {
        let nVoters = users.filter(user => user.isApproved === true).length
        let nVotes = votes.length
        let nShares = 0
        const xlVotes = [];
        votes.map(vote => {
            if(vote.nominees) {
                const vote_data = { ...vote }
                var nominee_list = ''
                vote_data.nominees = vote.nominees.join(", ")
                xlVotes.push(vote_data)
            } else {
                vote.nominees = ''
                xlVotes.push(vote)
            }

            if(vote.vote1) return nShares += parseInt(vote.noOfShares)
            return
        })
        console.log(xlVotes)
        setExcelvotes(xlVotes)
        setVoters(nVoters)
        setNoVotes(nVotes)
        setNoShares(nShares)
        
    }, [users])

    return (
        <div>
            {
                auth.isLoggedIn ? (
                    <>
                        <Title>Tabulation of Votes</Title>
                        <Row gutter={[16, 16]}>
                            <Col span={8}>
                                <Card style={{ padding: '16px 20px 8px'}} hoverable>
                                    <div className="card-chartTop">
                                        <div className="card-metaWrap">
                                            <div className="card-index-meta">
                                                <span>Total Number of Voters</span>
                                            </div>
                                            <div className="card-index-total">{voters}</div>
                                        </div>
                                    </div>
                                    <div className="card-index-footer">
                                        Approved Stockholders
                                    </div>
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card style={{ padding: '16px 20px 8px'}} hoverable>
                                    <div className="card-chartTop">
                                        <div className="card-metaWrap">
                                            <div className="card-index-meta">
                                                <span>Total Number of Votes</span>
                                            </div>
                                            <div className="card-index-total">{noVotes}</div>
                                        </div>
                                    </div>
                                    <div className="card-index-footer">
                                        Stockholders that voted
                                    </div>
                                </Card>
                            </Col>
                            <Col span={8}>
                                <Card style={{ padding: '16px 20px 8px'}} hoverable>
                                    <div className="card-chartTop">
                                        <div className="card-metaWrap">
                                            <div className="card-index-meta">
                                                <span>Total Number of Shares</span>
                                            </div>
                                            <div className="card-index-total">{noShares}</div>
                                        </div>
                                    </div>
                                    <div className="card-index-footer">
                                        Total shares of Stockholders that voted "Yes"
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                        <br />
                        <Table columns={columns} dataSource={votes} />
                        <ExcelFile element={<Button type='primary'>Export as Excel</Button>} filename="CREIT 2022 ASM - Tabulation of Votes">
                            <ExcelSheet data={excelvotes} name="List of Votes">
                                <ExcelColumn label="Timestamp" value="timestamp" />
                                <ExcelColumn label="Name of Stockholder" value="fullname" />
                                <ExcelColumn label="Number of Shares" value="noOfShares" />
                                <ExcelColumn label="Approval of the Minutes of the Annual Stockholders’ Meeting held on May 25, 2021" value="vote1" />
                                <ExcelColumn label="Election of Directors" value="vote2" />
                                <ExcelColumn label="Nominees" value="nominees" />
                                <ExcelColumn label="Ratification of the 2021 Audited Financial Statements" value="vote3" />
                                <ExcelColumn label="Appointment of Isla Lipana &amp; Co. as external auditor" value="vote4" />
                                <ExcelColumn label="Ratification of all acts of Management and the Board of Directors" value="vote5" />
                                <ExcelColumn label="Approval of the Amendment of By-Laws changing the date of the annual stockholders’ meeting from the first Monday of April to June 8 of every year." value="vote6" />
                                <ExcelColumn label="Approval of the issuance by the Company of fixed-rate bonds not exceeding thirty five percent (35%) of the value of its Deposited Property or up to the allowable leverage under the Real Estate Investment Trust (REIT) Act of 2009 (“REIT Law”) and its implementing rules and regulations (“REIT Law IRR”)." value="vote7" />
                            </ExcelSheet>
                        </ExcelFile>
                    </>
                ) : (
                    <Redirect to="/" />
                )
            }
        </div>
    )
}

export default Tabulation
